import IExtension from "../../IExtension";
import {Naja} from "naja";
import './dependentSelectBox';

export default class DependSelectBoxExtension implements IExtension {

    public initialize(naja: Naja): void {
        naja.addEventListener('init', () => this.init($('body')));
        naja.snippetHandler.addEventListener('afterUpdate', (e) => this.init($(e.detail.snippet)));
    }

    private init($root): void {
        $root.find('[data-dependentselectbox]')
            .not('.event-binded')
            .dependentSelectBox()
            .addClass('.event-binded')
    }
}
